import api from "./Api";

class ClienteEnderecoService {
  GetClienteEndereco(payload) {
    return api.get("/v1/clienteEndereco/" + payload).then((response) => {
      return response.data;
    });
  }

  PostClienteEndereco(payload) {
    return api.post("/v1/clienteEndereco/", payload).then((response) => {
      return response.data;
    });
  }

  PutClienteEndereco(payload) {
    return api.put("/v1/clienteEndereco/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteClienteEndereco(payload) {
    return api.delete("/v1/clienteEndereco/" + payload).then((response) => {
      return response.data;
    });
  }

  GetClienteEnderecoOData(payload) {
    return api.get("/OData/ClienteEndereco" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new ClienteEnderecoService();
